import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { media } from '../../services/media';
import { themeStyles } from '../../services/themeStyles';

const Formue = themeStyles(
    'formue',
    css`
        display: block;

        position: relative;

        text-align: center;
    `,
);

export const FormFieldLabel = styled.label`
    display: block;

    position: relative;
    /* margin-bottom: 1.5em; */

    /* font-size: 3.5vw; */
    text-align: center;

    ${media.min('md')} {
        /* margin-bottom: 4vw; */

        /* font-size: 2.45vw; */
    }

    ${media.min('xl')} {
        /* margin-bottom: 1em; */

        /* font-size: 1.86vw; */
    }

    ${Formue}

    &.error {
        .FormField__input {
            border-color: #ec7a7a;
        }
    }

    a {
        color: inherit;
    }

    /* span {
        display: block;
        margin-left: 0.3vw;
    } */

    &--checkbox {
        display: inline-block;

        position: relative;

        font-size: 3.1vw;

        ${media.min('md')} {
            font-size: 1.1vw;
        }

        .FormField__input {
            pointer-events: none;

            padding: 0;

            position: absolute;
            bottom: 0;
            left: 6px;
            margin: 0;

            opacity: 0;

            &:checked + span:after {
                opacity: 1;
            }
        }

        span {
            display: inline-flex;
            align-items: center;
            justify-content: center;

            position: relative;

            align-items: flex-start;

            &:before {
                content: '';

                display: inline-block;

                width: 16px;
                min-width: 16px;
                height: 17px;

                margin-right: 5px;

                border: 1px solid;
                border-radius: 50%;

                ${media.min('md')} {
                    width: 1.9vw;
                    min-width: 1.9vw;
                    height: 1.9vw;

                    margin-right: 0.5vw;

                    border: 0.15vw solid;
                }
            }

            &:after {
                content: '';

                width: 4px;
                height: 12px;

                position: absolute;
                top: 0;
                left: 8px;
                transform: rotate(45deg);

                border-right: 1px solid;
                border-bottom: 1px solid;
                opacity: 0;

                transition: opacity 0.3s;

                ${media.min('md')} {
                    width: 0.6vw;
                    height: 1.4vw;

                    top: -0.1vw;
                    left: 0.9vw;

                    border-right: 0.15vw solid;
                    border-bottom: 0.15vw solid;
                }
            }
        }
    }
`;
